module.exports = __webpack_public_path__ + "img/_checkbox.6a0c0636.svg";